function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 4C8.34498 4 7 5.34498 7 7C7 8.65502 8.34498 10 10 10C11.655 10 13 8.65502 13 7C13 5.34498 11.655 4 10 4Z",
  fill: "#072E4B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 0C5.45454 0 1.57274 2.90264 0 7C1.57274 11.0973 5.45454 14 10 14C14.55 14 18.4273 11.0973 20 7C18.4273 2.90264 14.55 0 10 0ZM10 11.6666C7.49091 11.6666 5.45454 9.57596 5.45454 6.99996C5.45454 4.42396 7.49091 2.33332 10 2.33332C12.5091 2.33332 14.5455 4.424 14.5455 7C14.5455 9.576 12.5091 11.6666 10 11.6666Z",
  fill: "#072E4B"
});

var SvgShoweye = function SvgShoweye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoweye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/showeye.32e0d719.svg";
export { ForwardRef as ReactComponent };